import { PortableTextBlock } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Container, Section } from 'components/GridV2';
import { SanityIcon } from 'components/SanityIcon';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { GetKOHOBtn } from 'components/rebrand/GetKOHOBtn';

import { IQueryParams, ISanityImgWithAltText, ITrackEventProps } from 'typescriptDefs';
import { IRentersHeroBenefits } from 'typescriptDefs/pages/renters';

interface Props {
  data: {
    heading: PortableTextBlock | PortableTextBlock[];
    subheading: string;
    buttonText: string;
    heroImage: ISanityImgWithAltText;
    heroBenefits: IRentersHeroBenefits[];
    tracking: {
      queryParams: IQueryParams;
      trackEventProps: ITrackEventProps;
    };
  };
}

const Hero = ({ data }: Props) => {
  return (
    <Section>
      <Container className="px-32 pb-64 pt-40 md:px-[unset] md:pb-72 md:pt-64">
        <div className="mb-64 grid items-center gap-64 md:mb-80 md:grid-cols-2 md:gap-32">
          <div>
            <div className="mb-24 text-center md:text-left [&_h1]:uppercase [&_h1]:text-primary-400 [&_h1_strong]:text-primary-200">
              <CustomPortableText content={data.heading} />
            </div>
            <p className="mb-48 text-center text-lg md:w-[75%] md:text-left md:font-medium">{data.subheading}</p>
            <GetKOHOBtn
              buttonLocation="renters"
              queryParams={data.tracking.queryParams}
              trackEventProps={data.tracking.trackEventProps}
              buttonClassName="w-full md:w-auto"
            >
              {data.buttonText}
            </GetKOHOBtn>
          </div>
          <div>
            <GatsbyImage image={data.heroImage.img.asset.gatsbyImageData} alt={data.heroImage.altText} />
          </div>
        </div>
        <div className="grid grid-cols-2 justify-between gap-32 md:grid-cols-3">
          {data.heroBenefits.map((benefit) => (
            <div key={benefit.altText} className="flex flex-col items-center gap-12 last:col-span-2 md:last:col-span-1">
              <SanityIcon icon={{ img: benefit.image, altText: benefit.altText }} />
              <p className="text-center text-md">{benefit.text}</p>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default Hero;
